import React from 'react';

import style from './TextBullets.module.scss';
import cx from 'classnames';
import { Body } from 'components/text';

type TextBulletsProps = {
  content: string;
  separator?: string;
  bulletStyle?: 'dot' | 'dash' | 'arrow' | 'star' | 'check' | 'number';
  className?: string;
  itemClassName?: string;
  bulletClassName?: string;
};

const TextBullet = ({
  content,
  separator = '<br />',
  bulletStyle = 'dot',
  className = '',
  itemClassName = '',
  bulletClassName = '',
}: TextBulletsProps) => {
  const bulletStyles = {
    dot: '•',
    dash: '–',
    arrow: '→',
    star: '★',
    check: '✓',
    number: null,
  };

  const items = content
    .split(separator)
    .map(item => item.trim())
    .filter(item => item.length > 0);

  const getBulletContent = (index: number) => {
    if (bulletStyle === 'number') {
      return `${index + 1}.`;
    }
    return bulletStyles[bulletStyle] || bulletStyles.dot;
  };

  return (
    <div className={className}>
      <ul className={style.listContainer}>
        {items.map((item, index) => (
          <li key={index} className={cx(style.item, itemClassName)}>
            <p className={bulletClassName}>{getBulletContent(index)}</p>
            <p>{item}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TextBullet;
